/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { List } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import type { RelayProps } from 'react-relay';

import TutorJobHistory from './job/TutorJobHistory';
import TutorJobEmptyItem from './job/TutorJobEmptyItem';

type Props = {} & RelayProps;

class TutorHistory extends Component<Props> {
  handleLoadMore = () => {
    this.props.relay.setVariables({
      first: this.props.relay.variables.first + 10,
    });
  };

  render() {
    const { tutor: { history: { edges, pageInfo } } } = this.props;

    return (
      <div>
        <List>
          {edges.length > 0 ? (
            edges.map(({ node }) => (
              <TutorJobHistory key={node.id} node={node} />
            ))
          ) : (
            <TutorJobEmptyItem />
          )}
        </List>

        <RaisedButton
          label="Load More"
          disabled={!pageInfo.hasNextPage}
          fullWidth
          secondary
          onClick={this.handleLoadMore}
        />
      </div>
    );
  }
}

export default createFragmentContainer(TutorHistory, {
  tutor: graphql`
    fragment TutorHistory_tutor on Tutor {
      history: jobs(first: 10, status: [Completed]) {
        edges {
          node {
            id
            createdAt
            acceptedJobOffer {
              sessions {
                timeSlot {
                  id
                  startDate
                  duration {
                    hours
                    minutes
                  }
                }
              }
              jobRequest {
                subject {
                  name
                }
                grade {
                  name
                }
                student {
                  firstname
                  lastname
                  profilePictureThumbnailUri
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorHistory.js